import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ContextAwarePaneHeader, Page, Pane, PaneBackButton, PaneBody } from '../../atoms/applications/page';
import { CalendarView } from '../../molecules/calendar/CalendarView';
import moment from 'moment-timezone';
import { action, computed, observable, reaction } from 'mobx';
import './startDateSelectionPane.module.scss';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';
import { MulticreatorStartDateSummary } from '../../atoms/applications/MulticreatorStartDateSummary';

type Props = {
    applicationState: BaseApplicationPageState;
};

@inject('applicationState')
@observer
export class BeautyStartDateSelectionPane extends React.Component<Props> {
    @observable selectionStartDate = null;
    @observable selectableDates = null;
    @observable init = false;
    cleanUp = null;

    componentDidMount(): void {
        this.selectionStartDate = moment().startOf('day');
        this.cleanUp = reaction(() => this.selectionEndDate, this.initialize);
        this.initialize();
    }

    componentWillUnmount(): void {
        if (this.cleanUp) {
            this.cleanUp();
        }
    }

    @action.bound
    initialize() {
        const { applicationPage } = this.props.applicationState;
        this.selectableDates = applicationPage.fixed_effective_dates;
        if (this.selectableDates.length == 0) {
            for (
                let currentDate = moment(this.selectionStartDate);
                currentDate.isBefore(this.selectionEndDate);
                currentDate = moment(currentDate).add(1, 'day')
            ) {
                this.selectableDates.push(currentDate);
            }
        }
        this.init = true;
    }

    @computed
    get selectionEndDate() {
        const { applicationPage } = this.props.applicationState;
        if (!applicationPage || !applicationPage.expires_at) {
            return moment().add(2, 'month');
        }
        return moment(applicationPage.expires_at);
    }

    render() {
        const { name, canGoBack, startDate, setStartDate, validateStartDateAndNext } = this.props.applicationState;
        if (!this.init) {
            return null;
        }
        return (
            <Page>
                <Pane styleName="pane">
                    {canGoBack && <PaneBackButton />}
                    <ContextAwarePaneHeader planName={name}>受講開始日の選択</ContextAwarePaneHeader>
                    <PaneBody>
                        <div styleName="lead-text">選択した日からプランの適用が開始されます</div>
                        <div styleName="body">
                            <div styleName="calendar">
                                <CalendarView
                                    startDate={this.selectionStartDate}
                                    endDate={this.selectionEndDate}
                                    selectedDate={startDate}
                                    clickables={this.selectableDates}
                                    onClick={setStartDate}
                                    onMonthChange={() => null}
                                />
                            </div>
                            <MulticreatorStartDateSummary date={startDate} onSubmit={validateStartDateAndNext} />
                        </div>
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
